export const videoRoles = ["SystemAdmin", "VtDemo", "CommunityManager"];
export const canAccessVideo = (role = localStorage.getItem("role")) =>
  videoRoles.some(allowed => allowed.toLowerCase() === String(role || "").replace(/\s+/g, "").toLowerCase());
